import { createFileRoute } from '@tanstack/react-router';

import { DisciplineBrowse } from '@/module/Discipline/DisciplineBrowse';

export const Route = createFileRoute('/_auth/administration/_administration/discipline/_discipline/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <DisciplineBrowse />;
}
